<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup Area
 * @created at      :   2026/01/20
 * @created by      :   ANS794 longvv@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupMST007 from '@/views/popupSearch/PopupMST007/store';
/**
 * Define component for popup Fab040120i
 */
import helpers from '@/utils/helpers';

var Area = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupMST007')) {
            store.registerModule('PopupMST007', PopupMST007);
        }
    },
    created() {
        this.onInitScreen();
        this.applyInitData();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupMST007', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupMST007', ['searchOfficeInfo']),
        ...mapMutations('PopupMST007', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        getAreaName(data) {
            this.data.department_name = data;
        },
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.company_cd !== undefined) {
                    this.data.company_cd = this.initData.company_cd;
                }
                if (this.initData.center_cd !== undefined) {
                    this.data.center_cd = this.initData.center_cd;
                }
                if (this.initData.department_cd !== undefined) {
                    this.data.department_cd = this.initData.department_cd;
                }
                if (this.initData.group_cd !== undefined) {
                    this.data.group_cd = this.initData.group_cd;
                }
                if (this.initData.department_name !== undefined) {
                    this.data.department_name = this.initData.department_name;
                }
                if (this.initData.office_cd !== undefined) {
                    this.data.office_cd = this.initData.office_cd;
                }
                if (this.initData.office_name !== undefined) {
                    this.data.office_name = this.initData.office_name;
                }
            }
        },
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchOfficeInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchOfficeInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(data) {
            this.$emit('onReferModelValue', data.office_cd);
            this.$emit('onReferValueName', data.office_name);
            this.$emit('close');
        }
    }
};
export default Area;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
